import { render, staticRenderFns } from "./Sticker.vue?vue&type=template&id=a237a322&"
import script from "./Sticker.vue?vue&type=script&lang=js&"
export * from "./Sticker.vue?vue&type=script&lang=js&"
import style0 from "./Sticker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports